import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import Vant from 'vant';
import 'vant/lib/index.css';


// 引入自定义全局黑金主题
import '@/styles/black-gold-theme.css';

// 引入全局样式
import './styles/sweetalert.css';
import './styles/mobile-scroll-fix.css';

import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'

const queryClient = new QueryClient()

// 引入 Pinia
import { createPinia } from 'pinia';

const app = createApp(App);

app.use(router);
app.use(Vant);


app.use(VueQueryPlugin, { queryClient });
app.use(createPinia()); // 注入 Pinia
app.mount('#app');
